import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const CardActions = forwardRef(function CardActions({
  children,
  left,
  right,
  disableGutters = false,
  gutters,
  className,
}, ref) {
  return (
    <div
      ref={ref}
      className={cx(
        'hms-card-actions',
        disableGutters && 'hms-card-actions__no-gutters',
        gutters && `hms-card-actions__gutters-${gutters}`,
        className,
      )}
    >
      {left && <div className="hms-card-actions__left">{left}</div>}
      {children}
      {right && <div className="hms-card-actions__right">{right}</div>}
    </div>
  );
});

CardActions.propTypes = {
  children: T.node,
  left: T.node,
  right: T.node,
  disableGutters: T.bool,
  // Default gutters size 16px 24px
  // Supported sizes:
  // To add support more sizes, add appropriate styles to _hms-card.scss
  // Gutters format for two axis: '16-24'
  gutters: T.oneOfType([T.number, T.string]),
  className: T.string,
};

export default CardActions;
